var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 134.106,
    height: 134.106,
    rx: 67.0529,
    fill: "#575E76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8306 63.6084C57.4398 63.6084 63.6084 57.4398 63.6084 49.8306C63.6084 42.2213 57.4398 36.0527 49.8306 36.0527C42.2213 36.0527 36.0527 42.2213 36.0527 49.8306C36.0527 57.4398 42.2213 63.6084 49.8306 63.6084ZM49.8309 56.7195C53.6355 56.7195 56.7198 53.6352 56.7198 49.8306C56.7198 46.0259 53.6355 42.9417 49.8309 42.9417C46.0262 42.9417 42.9419 46.0259 42.9419 49.8306C42.9419 53.6352 46.0262 56.7195 49.8309 56.7195Z",
    fill: "#009D81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2749 63.6084C91.8842 63.6084 98.0527 57.4398 98.0527 49.8306C98.0527 42.2213 91.8842 36.0527 84.2749 36.0527C76.6656 36.0527 70.4971 42.2213 70.4971 49.8306C70.4971 57.4398 76.6656 63.6084 84.2749 63.6084ZM84.2753 56.7195C88.08 56.7195 91.1642 53.6352 91.1642 49.8306C91.1642 46.0259 88.08 42.9417 84.2753 42.9417C80.4707 42.9417 77.3864 46.0259 77.3864 49.8306C77.3864 53.6352 80.4707 56.7195 84.2753 56.7195Z",
    fill: "#272A39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2749 98.0526C91.8842 98.0526 98.0527 91.8841 98.0527 84.2748C98.0527 76.6655 91.8842 70.4969 84.2749 70.4969C76.6656 70.4969 70.4971 76.6655 70.4971 84.2748C70.4971 91.8841 76.6656 98.0526 84.2749 98.0526ZM84.2753 91.1636C88.08 91.1636 91.1642 88.0793 91.1642 84.2746C91.1642 80.47 88.08 77.3857 84.2753 77.3857C80.4707 77.3857 77.3864 80.47 77.3864 84.2746C77.3864 88.0793 80.4707 91.1636 84.2753 91.1636Z",
    fill: "#E34322"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8306 98.0526C57.4398 98.0526 63.6084 91.8841 63.6084 84.2748C63.6084 76.6655 57.4398 70.4969 49.8306 70.4969C42.2213 70.4969 36.0527 76.6655 36.0527 84.2748C36.0527 91.8841 42.2213 98.0526 49.8306 98.0526ZM49.8309 91.1636C53.6355 91.1636 56.7198 88.0793 56.7198 84.2746C56.7198 80.47 53.6355 77.3857 49.8309 77.3857C46.0262 77.3857 42.9419 80.47 42.9419 84.2746C42.9419 88.0793 46.0262 91.1636 49.8309 91.1636Z",
    fill: "#272A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo3);
export default __webpack_public_path__ + "static/media/co-3.0aedf170e23fd9a4e2c90c38f1a77d72.svg";
export { ForwardRef as ReactComponent };